import {GetObligationPdf, GetObligationPdfParams, GetObligationPdfModel} from 'domain/usecases';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteGetObligationPdf implements GetObligationPdf {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetObligationPdfModel>,
	) {}

	async get({signal, ...params}: GetObligationPdfParams): Promise<GetObligationPdfModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			responseType: params.responseType,
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
